import type Result from 'true-myth/result';

import type { UserSettings } from '~/shared/data-contract/user-settings-schema';
import { userSettingsSchema } from '~/shared/data-contract/user-settings-schema';
import type { ValidatingHttpFetcherWithBaseUrl } from '~/shared/validating-http-fetcher';

import type { UserSettingsPayload } from './user-settings';

export type UpdateUserSettings = (userSettings: UserSettingsPayload) => Promise<Result<UserSettings, unknown>>;

export const createUpdateUserSettings = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): UpdateUserSettings => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return (userSettings) => {
        return validatingCobrainerApiFetcher.patchJson(userSettingsSchema, {
            pathname: `/users/me/settings`,
            payload: userSettings,
        });
    };
};
